<template>
  <div
    class="  cursor-pointer list-group mt-2  w-full flex items-start    justify-start         flex flex-row justify-center  ">
    <div v-if="properties != undefined" class="w-full">
      <div class="flex flex-col items-start w-full justify-start  pt-6  px-2 w-full">
        <div v-if="displayRequired" class="  mb-6 w-full text-left">
          <label for="default-input"
            class="w-full  block mb-2 text-sm font-medium text-gray-900 ">Contraintes</label>

          <div class="hidden  block text-black">
            {{ properties }}
          </div>

          <div class="flex w-full ">
            <div class="flex items-center w-full  ">
              <input id="inline-checked-checkbox" v-model="isRequired" checked type="checkbox"
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
                @change="onChangeIsRequired">
              <label for="inline-checked-checkbox"
                class="ms-2 text-sm font-medium text-gray-900 ">Champ Obligatoire</label>
            </div>
          </div>


          <hr class="mt-2 mb-2"/>




          <div class="flex w-full mt-3">
            <div class="flex justify-center items-center w-full  ">

              <div class="flex flex-col space-y-1">
                <button type="button"
                  class="px-3 py-2 text-xs font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300   "
                  @click="onHiddenRules">
                   Gestion Hidden
                </button>
              </div>
            </div>
          </div>


          <div class="flex w-full mt-3">
            <div class="flex justify-center items-center w-full  ">

              <div class="flex flex-col space-y-1">
                <button type="button"
                  class="px-3 py-2 text-xs font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300   "
                  @click="onReadOnlyRules">
                   Gestion ReadOnly
                </button>
              </div>
            </div>
          </div>


          </div>

          <div v-if="displayMessage" class="  mb-6 w-full text-left">
            <label for="default-input"
              class="block mb-2 text-lg font-medium text-gray-900 ">Contraintes</label>

            <div class="hidden  block text-black">
              {{ properties }}
            </div>

            <div class="flex">
              <div class="flex items-center me-4">
                <input id="disabled-checkbox" disabled type="checkbox" value=""
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    ">
                <label for="disabled-checkbox" class="ms-2 text-sm font-medium text-gray-400 ">Champ
                  Obligatoire</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
  export default {
    name: 'ControlsTableFormComponentDetails',
    props: {
      properties: Object,
      index: Number,
      definition: Object
    },
    data() {

      return {
        isRequired: true
      }
    },
    computed: {
      displayRequired: function () {
        if (this.properties?.type == 'avatar') return true
        if (this.properties?.type == 'radio') return true
        if (this.properties?.type == 'edit') return true
        if (this.properties?.type == 'button') return true
        if (this.properties?.type == 'date') return true

        if (this.properties?.type == 'scan-code') return true


        if (this.properties?.type == 'number') return true
        return false;
      },
      displayMessage: function () {
        if (this.properties?.type == 'avatar') return false
        if (this.properties?.type == 'radio') return false
        if (this.properties?.type == 'edit') return false
        if (this.properties?.type == 'date') return false
        if (this.properties?.type == 'scan-code') return false
        if (this.properties?.type == 'button') return false
        if (this.properties?.type == 'number') return false
        return true;
      }
    },
    watch:
    {
      properties: function () {
        this.isRequired = this.properties?._controls?.isRequired;
        if (this.isRequired == undefined) this.isRequired = true
      }
    },

    mounted() {
      this.isRequired = this.properties?._controls?.isRequired
      if (this.isRequired == undefined) this.isRequired = true

    },
    methods:
    {
      onReadOnlyRules : function()
      {
        this.$emit("queryBuilder", {type:"read-only"});
      },
      onHiddenRules : function()
      {
        this.$emit("queryBuilder", {type:"hidden"});
      },
      onChangeIsRequired: function () {
        this.$emit("updateField", { id: this.properties?.id, tab: "controls", att: '_controls', value: { isRequired: this.isRequired } })
      }
    }
  }
</script>